import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export class OrganisationApiService extends ApiService {
  static async getVariables(organisationId: string): Promise<IServiceResponse<object>> {
    return this.axios.get(`organisations/${organisationId}/variables`)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }

  static async saveVariables(organisationId: string, data: object): Promise<IServiceResponse<object>> {
    return this.axios.post(`organisations/${organisationId}/variables`, data)
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
